import { approvalStateApi, ekycApi, sarApi } from '@/apis';
import { PRESCREENING } from '@/constants';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  clearError({ commit }) {
    commit('setError', null);
  },
  clearSar({ commit }) {
    commit('setSar', null);
    commit('setError', null);
  },
  async initSarNewUsers({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchUsers')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async incrementUsers({ commit, dispatch }, params) {
    commit('setAdding', true);
    await dispatch('fetchUsers', params);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async searchUsers({ commit, dispatch }, params) {
    commit('setUsers', []);
    commit('setLoading', true);
    await dispatch('fetchUsers', params);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {Object} params
   */
  async fetchUsers({ commit, dispatch, rootGetters }, params = {}) {
    const token = rootGetters['auth/token'];
    try {
      const approvalState = await dispatch('fetchApprovalState');
      if (approvalState && approvalState.id) {
        params.approval_state_id = approvalState.id;
        const response = await ekycApi.requestList(token, params);
        commit('addUsers', response.data.result);
        commit('setPaging', response.data.paging);
      }
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Object} rootGetters
   * @returns {Promise<Object>}
   */
  async fetchApprovalState({ rootGetters }) {
    const token = rootGetters['auth/token'];
    const response = await approvalStateApi.requestAll(token);
    const item = response.data.find(
      (item) => item.approval_key === PRESCREENING.APPROVAL_KEY.COMPLETED,
    );
    return item;
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initSarNewTypes({ commit, dispatch }) {
    commit('setLoading', true);
    const requests = [dispatch('fetchTypes')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchTypes({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    commit('setTypes', []);
    try {
      const response = await sarApi.requestTypes(token);
      commit('setTypes', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initSarNewEffects({ commit, dispatch }) {
    commit('setLoading', true);
    const requests = [dispatch('fetchEffects')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchEffects({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    commit('setEffects', []);
    try {
      const response = await sarApi.requestEffects(token);
      commit('setEffects', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   * @param {Object} payload
   */
  saveSar({ commit, getters }, payload) {
    const oldSar = getters['sar'];
    const sar = { ...oldSar, ...payload };
    commit('setSar', sar);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   * @param {Object} payload
   */
  saveFiles({ commit, getters }, payload) {
    const oldSar = getters['sar'];
    if (oldSar['document_files']) {
      oldSar['document_files'] = [];
    }
    const sar = { ...oldSar, ...{ document_files: payload } };
    commit('setSar', sar);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async submitNewSar({ commit, rootGetters }, { data }) {
    const token = rootGetters['auth/token'];
    commit('setLoading', true);
    try {
      const response = await sarApi.requestCreate({
        token,
        data,
      });
      return response.data;
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setLoading', false);
    }
  },
};
